import React from 'react';

import { TESTIMONIAL_CHOICES } from './TestimonialWizard';
import { MARKERS, DEFAULT_MARKER } from './ContribsMap';
import { getImageUrl } from './ImageUtils';



export default ({ contrib, isOpen, onClose }) => {

  // be conservative, things may have changed

  const testimonial = TESTIMONIAL_CHOICES[contrib.testimonial_choice] || {major_choices: {}};

  const major = testimonial ? (
    testimonial.major_choices[contrib.major_reason_choice] || {}
  ) : {};

  const firstTitle = testimonial.label || '';
  const secondTitle = major.label ||'';

  const marker = major ? MARKERS[major.icon] || DEFAULT_MARKER : DEFAULT_MARKER;

  const imageUrl = getImageUrl(contrib.image);

  return (
    <div className={`modal-contrib modal${isOpen ? ' is-active' : ''}`}>
      <div className="modal-background"
        onClick={onClose}
      >
      </div>
      <div className="modal-content">
        <div className="box">
          <div class="gp-close-icon" onClick={onClose}>
            <span class="icon">
              <i class="fa fa-window-close"></i>
            </span>
          </div>
          <div class="columns is-vcentered is-mobile">
            <div class="column is-narrow">
              <div className="gp-popup-picto">
                <img src={marker} alt=""/>
              </div>
            </div>
            <div class="column has-text-centered">
              <span className="gp-popup-title is-block-mobile">{firstTitle}</span>
              <span className="gp-popup-title is-hidden-mobile"> - </span>
              <span className="gp-popup-title is-block-mobile">{secondTitle}</span>
            </div>
          </div>
          <div class="gp-popup-sub-title">
            {contrib.name}, {contrib.age} ans, {contrib.city}
          </div>
          <div class="columns row-reverse">
            <div class="column">
              <p className="gp-texte">
                «&nbsp;{contrib.message}&nbsp;»
              </p>
            </div>
            {imageUrl ? (
              <div class="column gp-popup-picture">
                <img src={imageUrl} alt="" />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
